<template>
	<div >
		<v-row justify="center">
			<v-col cols="12" md="12" class="text-right py-0">


				<v-btn color="error" v-if="agent_details.is_payout_allowed" @click="confirmTogglePayouts($lang.DISABLE_PAYOUT)" > 
					<b>{{$lang.DISABLE_PAYOUT}}</b>
				</v-btn>
				<v-btn    color="primary" v-if="!agent_details.is_payout_allowed" @click="confirmTogglePayouts($lang.ENABLE_PAYOUT)"> 
					<b>{{$lang.ENABLE_PAYOUT}}</b>
				</v-btn>

				<v-btn text small  > 
					<img src="@/assets/view.svg" alt="img" class="mr-1">
					<span class="secodry-text-2">{{$lang.VIEW_PAYOUT}}</span>
				</v-btn>
				<v-btn text small @click="$router.push({name:'edit-agent',params:{agent_id:encript(agent_id)}})"  > 
					<img src="@/assets/edit.svg" alt="img" class="mr-1">
					<span class="secodry-text-2">{{$lang.EDIT}}</span>
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="start">
			<v-col cols="6" md="4">
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.NAME}}</p>
					<p class="secondary-text">{{ agent_details.agent_name }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.PHONE_NUMBER}}</p>
					<p class="secondary-text">{{ agent_details.agent_phone_number }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.ALTERNATE_PHONE_NUMBER}}</p>
					<p class="secondary-text">{{ agent_details.agent_alternate_phone_number }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.AADHAAR_NUMBER}}</p>
					<p class="secondary-text">{{ agent_details.agent_aadhar_number }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.DL_NUMBER}}</p>
					<p class="secondary-text">{{ agent_details.agent_driving_license_number }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.DL_EXPIRY}}</p>
					<p class="secondary-text">{{ agent_details.agent_driving_license_expiry }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.FULL_ADDRESS}}</p>
					<p class="secondary-text">{{ agent_details.agent_address }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.ASSETS}}</p>
					<p class="secondary-text">{{ agent_details.agent_assets }}</p>
				</div>
				
			</v-col>
			<!-- BLANK DATA -->
			<v-col cols="6" md="1" class="border-r">
			</v-col>
			<!--  -->
			<v-col cols="6" md="5" class="pl-6">
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.TYPE}}</p>
					<p class="secondary-text">{{ agent_details.agent_type }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.BANK_NAME}}</p>
					<p class="secondary-text">{{ agent_details.agent_bank_name }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.ACCOUNT_HOLDER_NAME}}</p>
					<p class="secondary-text">{{ agent_details.agent_bank_account_holder_name }}</p>
				</div>	
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.ACCOUNT_NUMBER}}</p>
					<p class="secondary-text">{{ agent_details.agent_bank_account_number }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.IFSC}}</p>
					<p class="secondary-text">{{ agent_details.agent_bank_ifsc }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.PAN_CARD}}</p>
					<p class="secondary-text">{{ agent_details.agent_pancard_number }}</p>
				</div>
				<div class="mb-5">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.CREDIT_LIMIT}}</p>
					<p class="secondary-text">{{ agent_details.agent_credit_limit }}</p>
				</div>
				<div class="mb-5" v-if="agent_details.agent_document">
					<p class="page-title fs-16 fw-bold text-left"> {{$lang.DOCUMENT}}</p>
					<a class="secondary-text" :href="agent_details.agent_document" target="_blank">
						<span class="underline secondary-text">{{ agent_details.agent_name }}</span>
						<img src="@/assets/download.svg" alt="" class="ml-2 v-align-top">
					</a>
				</div>
			</v-col>
		</v-row>

		<common-confirmation-dialog :dialog="dialog" :YesClickHanler="togglePayoutaccess"/>

		</div>
	</template>
	<script type="text/javascript">

	export default{
		components:{
			CommonConfirmationDialog:()=> import('@/components/common-components/CommonConfirmationDialog.vue'),
		},
		data(){
			return{
				agent_id:"",
				agent_details:{
					agent_name:"",
					agent_phone_number:"",
					agent_alternate_phone_number:"",
					agent_aadhar_number:"",
					agent_driving_license_number:"",
					agent_driving_license_expiry:"",
					agent_assets:"",
					agent_type:'',
					agent_bank_name:"",
					agent_bank_account_number:"",
					agent_bank_account_holder_name:"",
					agent_bank_ifsc:"",
					agent_pancard_number:"",
					agent_credit_limit:"",
					agent_address:"",
					file:"",
				},
				dialog:{
					flag:false,
					msg:"",
				}
			}
		},
		created(){
			if (this.$route.params.agent_id){
				this.agent_id= this.decrypt(this.$route.params.agent_id)
				this.getAgentDetails()
			} 
		},
		methods:{
			/* fetch agent details*/ 
			getAgentDetails(){
				const self=this
				self.$store.dispatch('setPageLoader', true)
				self.filter_agent_type=status
				let params={
					id:self.agent_id,
				};

				self.table_loading=true;
				const successHandler = (response) => {
					self.agent_details=response.data.data
				};
				const finallyHandler = () => {
					self.$store.dispatch('setPageLoader', false)
				};
				self.request_GET( self,self.$urls.AGENT_PROFILE,params,successHandler,null,null,finallyHandler)
			},
			confirmTogglePayouts(status){
				this.dialog.flag=true
				this.dialog.msg="want to "+status +"."
			},
			/* Add edit agent details*/ 
			togglePayoutaccess(){
				const self= this
				var	form = new FormData();

				form.append("id",self.agent_id)  
				const successHandler = (response) => {
					if (response.data.success){
						this.dialog.flag=false
						this.getAgentDetails()
					}
				};

				const finallyHandler = () => {
					self.btn_loading=false
				};
				this.request_POST(self,self.$urls.CHANGE_AGENT_PAYOUT_STATUS,form,successHandler,null,null,finallyHandler)

			},
		}

	}

	</script>